import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import PgmaRatesEditor from './PgmaRatesEditor';
import RcProRatesEditor from './RcProRatesEditor';
import PgmRatesEditor from './PgmRatesEditor';

const labelStyle = { fontSize: 11, fontWeight: 600, color: S.textSecondary, textTransform: 'uppercase', letterSpacing: 0.6 };

const RateTablesPanel = () => {
  const { t } = useTranslation();
  const [product, setProduct] = useState('PGMA');

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '20px 32px 40px' }}>
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{t('rateTables.product')}</label>
        <select
          value={product}
          onChange={e => setProduct(e.target.value)}
          style={{
            marginTop: 6,
            padding: '8px 12px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            color: S.textPrimary,
            cursor: 'pointer',
            minWidth: 320,
            display: 'block',
          }}
        >
          <option value='PGMA'>{t('rateTables.productPgma')}</option>
          <option value='RC_PRO'>{t('rateTables.productRcPro')}</option>
          <option value='PGM'>{t('rateTables.productPgm')}</option>
        </select>
      </div>

      {product === 'PGMA'   && <PgmaRatesEditor />}
      {product === 'RC_PRO' && <RcProRatesEditor />}
      {product === 'PGM'    && <PgmRatesEditor />}
    </div>
  );
};

export default RateTablesPanel;
